import React from 'react'
export default () => {
  return (
    <div>
    <section  className="TestDrive">
   <div className="emergencybanner"hidden><p><i>***<a href="https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=header&utm_medium=website&utm_content=header&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic">Apply now</a>, to find out if you are eligible to receive a free laptop and free education in any of our 101, 102, 201 and 301 courses!***</i></p>
          </div>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-md-8-explore-home-page col-md-offset-2-home-page">
              <h1>YOU + Code Fellows + AI</h1>
              <h1>=</h1>
               <h1>A Life Changing New Career!</h1>
              <div className="TestDrive-buttons">
              <a className="btn btn-primary explore-btn" href="/courses/code-101/explore-software-development/">Explore Software Development with AI</a>
              <a className="btn btn-primary explore-btn" href="/courses/ops-101/explore-cybersecurity/">Explore Cybersecurity with AI</a>
              <a className="btn btn-primary explore-btn" href="/courses/web3-101/explore-cryptocurrencies-and-web3-careers/">Explore Web3 with AI</a>
              </div>
          </div>
          </div>
        </div>
      </section>
      <section className="Stats">
        <div className="container">
          <div className="row">
            <div className="single-stat">
              <div className="mobile">
                <div>
                   <h4>93%</h4>
                  <h5><a href="/employment-data/">In-field Job Placement</a></h5>
                </div>
                <div>
                 <h4>800+</h4>
                  <h5><a href="/employer-partnerships/">Unique Hiring Companies</a></h5>
                </div>
              </div>
              <div className="mobile">
                <div>
                  <h4>$4.7M+</h4>
                  <h5><a href="/scholarship-fund/">In Scholarships Awarded </a></h5>
                </div>
                <div>
                  <h4>22</h4>
                  <h5><a href="/powered-by-code-fellows/">Powered by Schools</a></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="StudentProfiles">
        <div className="container">
          <div className="row">
            <div className="profiles">
              <div className="mobile">
                <div className="singleProfile">
                  <img src="https://images.ctfassets.net/qjy3jg1udcmq/21fjLxG3SYSYM2OOQaUEEI/123268c24d4fa0159f58b5149bd17ee3/caleb-wells.png" alt="Caleb Wells" />
                  <p>"After Code Fellows, I’m ready to deal with a large gamut of industry practices. We were introduced to source control (git flow) and Agile methodology, and experienced working in a development team to pair program."</p>
                  <h5>Caleb Wells</h5>
                  <h6>Software Development Engineer, Alaska Airlines</h6>
                </div>
                <div className="singleProfile">
                  <img src="https://images.ctfassets.net/qjy3jg1udcmq/5dedhlSJHaeO8sIWYWWKuQ/231f6351820c96b3bd37c13e10b2f2c3/rae-helsel.png" alt="Rae Helsel" />
                  <p>"The teachers are amazing, and the curriculum is on point and well-organized, but the best part of the program for me was the sense of community. That’s everything."</p>
                  <h5>Rae Helsel</h5>
                  <h6>CEO | Developer, RĀNA</h6>
                </div>
              </div>
              <div className="mobile">
                <div className="singleProfile">
                  <img src="https://images.ctfassets.net/k428n7s2pxlu/4eNsB8T7a0yiMwyW6a0qIu/adef6fa6c8a250719cf94d7eb940a4b4/katlyn.jpeg" alt="Kaylyn Yuh" />
                  <p>"Code Fellows enables you to challenge your learning every day, and motivates you to be an impactful individual and a strong team player."</p>
                  <h5>Kaylyn Yuh</h5>
                  <h6>Software Developer, Bevy</h6>
                </div>
                <div className="singleProfile">
                  <img src="https://images.ctfassets.net/k428n7s2pxlu/3iMknAabmUccEMoCsCayMc/42dcd303df167db34d0d2517bda85a37/lee.jpeg" alt="Lee Broxson" />
                  <p>"The program—especially the project weeks—is focused on a pseudo-production situation. As a result, I got a good understanding of what a real-world dev job is like, and that is appealing to employers."</p>
                  <h5>Lee Broxson</h5>
                  <h6>Senior Software Engineer, Avalara</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Financing">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h1>Fund Your Future Career in Tech!</h1>
              <p>Financing Options for Every Budget.</p>
              <div className="financing-buttons">
                <a className="btn btn-primary" href="/financing-and-scholarships/#student-loans/">Financing</a>
              </div>
              <div className="financing-buttons">
                <a className="btn btn-primary" href="/scholarship-fund/">Scholarships</a>
              </div>
              <div className="financing-buttons">
                <a className="btn btn-primary" href="/gi-bill/">GI Bill®</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="Partners">
        <div className="container">
          <h1>Our Grads Have Been Hired By More than <strong>800</strong> Companies Including:</h1>
          <section className="Partners">
            <img src="https://images.ctfassets.net/k428n7s2pxlu/5M1h5WgG522soASEueSe20/aa2620c3f2f2531070db294bb424a2dc/why-hire-logo-grid.png" alt="hiring companies"></img>
          </section>
        </div>
      </section>
      <section>
        <div className="HomeHero">
          <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h1>Live Remote Instruction</h1>
              <p>Join our classes from anywhere in the world, and interact in real-time with our team of professional industry-leading instructors.</p>
              <div className="HomeHero-buttons">
              <a className="btn btn-primary" href="https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=homepage&utm_medium=website&utm_content=homepage&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic" >Apply Today</a>
            </div>
          </div>
          </div>
        </div>
        </div>
      </section>
      <section className="Subheader">
        <div className="container">
          <div className="row">
            <div className="col-md-12 badges">
               <a href="https://www.coursereport.com/schools/code-fellows">
                <div className="mega-buttons">
                  <img src="//images.ctfassets.net/k428n7s2pxlu/5JIajsMTOU0NQ0cHdgiTSy/ae7648c376fe4e489abd804ac44e3c0e/Best_Coding_Bootcamps_Badge_2023_New__2_.png" alt="Course Report"></img>
                </div>
              </a>
              <a href="https://www.switchup.org/bootcamps/code-fellows">
                <div className="mega-buttons">
                  <img src="//images.ctfassets.net/k428n7s2pxlu/yKQMr2YJhegfMq1Kgeks3/5f2e43e7849cfca4538d6e29d433258f/su-best-coding-2022-6years.png" alt="Switchup"></img>
                </div>
              </a>
              <a href="https://www.coursereport.com/schools/code-fellows">
               <div className="mega-buttons">
                 <img src="//images.ctfassets.net/k428n7s2pxlu/5Orp1b7wOQqcyGwpck1PM3/9b87ad9382e02720326654ac0eb3b3d6/Best_Online_Bootcamps_Badge_2022_New__1_.png"></img>
               </div>
             </a>
             <a href="https://careerkarma.com/schools/code-fellows/">
               <div className="mega-buttons">
                 <img src="//images.ctfassets.net/k428n7s2pxlu/1NyyNLfTMZeYAnpdrnN0Kz/499636e9a0671463b5b9f2d70c0bf5fe/Best__cyber_security_bootcamp.png" alt="Career Karma"></img>
               </div>
             </a>
            </div>
          </div>
        </div>
    </section>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/data/code/landing.js